import {ScreenExportScene} from "./ScreenExportScene";
import {CutPlanStick} from "../../../../../../api/ElevationTool";
import {computeCutPlan} from "./CutPlan";

// frame cut plan for the shop: the screen (frame) export with a letter on each stick. The sticks'
// lengths, profiles and end cuts are reported with the image and printed as a table under it.
export class CutPlanExportScene extends ScreenExportScene {
    protected includeTopDown(): boolean {
        return false;
    }

    // the cut plan is about the sticks; the anchors would sit over their letters.
    protected showAnchors(): boolean {
        return false;
    }

    // the cut plan lists sticks, not glass.
    protected glassScheduleRows() {
        return [];
    }

    // measure the sticks and draw each one's letter.
    protected cutPlanSticks(): CutPlanStick[] {
        if(!this.grid) return [];

        const plan = computeCutPlan(this.grid, this.elev);
        for(const m of plan.marks) m.mat.setCutLabel(m.label);
        return plan.sticks;
    }
}
